import { useMemo } from 'react'
import { extractUserGeometryInfoItems } from '@modules/MapScreen/components/MapGeometries/userGeometryFeatureInfo'
import { Assets } from '@nexds/web'
import GeoJSON from 'geojson'
import styled, { useTheme } from 'styled-components'

import { Body, CloseButton, Header, Label, MessageContainer, Section, Title, Value } from './InfoPanel.styles'

import { useI18n } from '@/presentation/hooks/useI18n'

// The geometry title is the feature's own name (often containing measurement
// units like "ft"), so it must keep its original casing instead of being
// upper-cased like the other panel titles.
const GeometryTitle = styled(Title)`
  text-transform: none;
`

interface UserGeometryFeatureInfoProps {
  title: string
  feature: GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>
  onClose?: () => void
}

function UserGeometryFeatureInfo({ title, feature, onClose }: UserGeometryFeatureInfoProps) {
  const { t } = useI18n()
  const theme = useTheme()

  const items = useMemo(
    () => extractUserGeometryInfoItems(feature.properties, { yesLabel: t('GLOBAL_YES'), noLabel: t('GLOBAL_NO') }),
    [feature, t]
  )

  return (
    <>
      <Header>
        <GeometryTitle>{title}</GeometryTitle>
        <CloseButton onClick={onClose}>
          <Assets.Close size={'md'} color={theme.colors.secondaryL3} />
        </CloseButton>
      </Header>
      <Body>
        {items.length > 0 ? (
          items.map((item) => (
            <Section key={item.key}>
              <Label $display="block">{item.label}</Label>
              <Value>{item.value}</Value>
            </Section>
          ))
        ) : (
          <MessageContainer>{t('USER-GEOMETRIES_FEATURE-INFO_NO-INFO')}</MessageContainer>
        )}
      </Body>
    </>
  )
}

export { UserGeometryFeatureInfo }
